import { m, useReducedMotion } from "framer-motion";
import { fadeUp, staggerContainer, transition, viewport } from "./presets";

export default function StaggerReveal({ children, className }) {
    const reduceMotion = useReducedMotion();

    if (reduceMotion) {
        return <div className={className}>{children}</div>;
    }

    return (
        <m.div
            className={className}
            initial="hidden"
            whileInView="visible"
            viewport={viewport}
            variants={staggerContainer}
        >
            {children}
        </m.div>
    );
}

export function StaggerItem({ children, className }) {
    const reduceMotion = useReducedMotion();

    if (reduceMotion) {
        return <div className={className}>{children}</div>;
    }

    return (
        <m.div className={className} variants={fadeUp} transition={transition}>
            {children}
        </m.div>
    );
}
